import { render } from "./AssessmentProcenaTimova.vue?vue&type=template&id=6be0dd78&scoped=true&lang=html"
import script from "./AssessmentProcenaTimova.vue?vue&type=script&lang=js"
export * from "./AssessmentProcenaTimova.vue?vue&type=script&lang=js"

import "./AssessmentProcenaTimova.vue?vue&type=style&index=0&id=6be0dd78&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-6be0dd78"

export default script